/**
 * persianToEnglishDigits
 *
 * تبدیل اعداد فارسی موجود در یک رشته به اعداد انگلیسی.
 *
 * این تابع تمام کاراکترهای عددی فارسی (۰ تا ۹) را در رشته ورودی پیدا کرده
 * و آن‌ها را به معادل انگلیسی خود (0 تا 9) تبدیل می‌کند.
 *
 * @param str رشته حاوی اعداد فارسی
 * @returns رشته‌ای با اعداد انگلیسی جایگزین شده
 *
 * @example
 * ```ts
 * const persianNumber = "۱۳۹۹/۰۵/۲۱";
 * const englishNumber = persianToEnglishDigits(persianNumber);
 * console.log(englishNumber); // "1399/05/21"
 * ```
 */
export const persianToEnglishDigits = (str: string): string => {
  return str.replace(/[۰-۹]/g, (d) => String("۰۱۲۳۴۵۶۷۸۹".indexOf(d)));
};


/**
 * Convert English digits to Persian digits
 */
export const englishToPersianDigits = (str: string): string => {
  return str.replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[parseInt(d)]);
};

/**
 * Format ISO date to readable Persian date with Persian digits
 */
export const formatPersianDate = (isoDate: string): string => {
  const date = new Date(isoDate);
  const persianDate = new Intl.DateTimeFormat('fa-IR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  }).format(date);
  
  return englishToPersianDigits(persianDate);
};
